import { forwardRef, ForwardedRef } from 'react';
import { SelectIcon } from '@vfit/shared-icons';
import TextInput from '../TextInput/textInput';
import { ISearchSelectProps } from './searchSelect.models';
import { SuggestionsWrapper, Suggestions, FillBorder } from './searchSelect.style';
import Flatlist from './components/flatList';
import { useSearchSelect } from './searchSelect.hook';

const SearchSelect = forwardRef<HTMLInputElement, ISearchSelectProps>(
  (props: ISearchSelectProps, ref: ForwardedRef<any>) => {
    const {
      items,
      value,
      setValue,
      setError,
      clearErrors,
      trigger,
      ignoreInnerErrors,
      searchable = true,
      label,
      placeholder,
      isDisabled,
      isErrorMessageDisabled,
      isErrorIconDisabled,
      errorMessage,
      hidden = false,
      ...rest
    } = props;

    const {
      showSuggestions,
      filteredItems,
      wrapperRef,
      toggleShowOptions,
      openOptions,
      onSelect,
      onChange,
      handleWrapperKeyDown,
      handleBlur,
      highlightedIndex,
    } = useSearchSelect({
      items,
      value,
      ignoreInnerErrors,
      isDisabled,
      searchable,
      setError,
      setValue,
      clearErrors,
      trigger,
    });

    return (
      <div>
        {!hidden && (
          <div ref={wrapperRef} onKeyDown={handleWrapperKeyDown}>
            <TextInput
              {...rest}
              value={value}
              placeholder={placeholder}
              error={errorMessage}
              label={label}
              ref={ref}
              isErrorMessageDisabled={isErrorMessageDisabled || showSuggestions}
              isErrorIconDisabled={isErrorIconDisabled}
              onFocus={openOptions}
              onClick={openOptions}
              onChange={onChange}
              onIconClick={toggleShowOptions}
              disabled={isDisabled}
              icon={<SelectIcon />}
              onBlur={handleBlur}
            />
            {showSuggestions && (
              <>
                {filteredItems.length > 0 && <FillBorder />}
                <SuggestionsWrapper className="suggestion-wrapper">
                  <Suggestions isError={!!errorMessage && !isErrorMessageDisabled}>
                    <Flatlist
                      onSelect={onSelect}
                      items={filteredItems}
                      itemCount={filteredItems.length}
                      highlightedIndex={highlightedIndex}
                    />
                  </Suggestions>
                </SuggestionsWrapper>
              </>
            )}
          </div>
        )}
      </div>
    );
  }
);

export default SearchSelect;

